window.POC = window.POC || {};

POC.ui = {
  getEl(id) {
    return document.getElementById(id);
  },

  showLoader() {
    var loader = this.getEl("poc-demo-loader");
    if (!loader) return;
    loader.style.display = "flex";
    loader.setAttribute("aria-hidden", "false");
  },

  hideLoader() {
    var loader = this.getEl("poc-demo-loader");
    if (!loader) return;
    loader.style.display = "none";
    loader.setAttribute("aria-hidden", "true");
  },

  setGlobalStatus(message, type) {
    var el = this.getEl("poc-demo-global-status");
    if (!el) return;
    el.className = "poc-demo-status " + (
      type === "success"
        ? "poc-demo-status--success"
        : type === "error"
          ? "poc-demo-status--error"
          : "poc-demo-status--info"
    );
    el.textContent = message;
  },

  setProductsStatus(message, type) {
    var el = this.getEl("poc-demo-products-status");
    if (!el) return;
    el.className = "poc-demo-status " + (
      type === "success"
        ? "poc-demo-status--success"
        : type === "error"
          ? "poc-demo-status--error"
          : "poc-demo-status--info"
    );
    el.textContent = message;
  },

  scrollToProductsAnchor() {
    var anchor = this.getEl("poc-demo-products-anchor");
    if (!anchor) return;
    anchor.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  },

  escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  },

  sanitizeHtml(html) {
    var template = document.createElement("template");
    template.innerHTML = String(html || "");

    var blockedTags = ["script", "iframe", "object", "embed", "link", "style", "meta"];
    blockedTags.forEach(function (tag) {
      var nodes = template.content.querySelectorAll(tag);
      Array.prototype.forEach.call(nodes, function (node) {
        node.remove();
      });
    });

    var allNodes = template.content.querySelectorAll("*");
    Array.prototype.forEach.call(allNodes, function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        var name = String(attr.name || "").toLowerCase();
        var value = String(attr.value || "").trim().toLowerCase();

        if (name.indexOf("on") === 0) {
          el.removeAttribute(attr.name);
          return;
        }

        if ((name === "href" || name === "src") && value.indexOf("javascript:") === 0) {
          el.removeAttribute(attr.name);
        }
      });
    });

    return template.innerHTML;
  },

  openModal() {
    var modal = this.getEl("poc-demo-modal");
    if (!modal) return;
    modal.style.display = "";
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  },

  closeModal() {
    var modal = this.getEl("poc-demo-modal");
    if (!modal) return;
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  },

  bindModalClose() {
    var closeBtn = this.getEl("poc-demo-modal-close");
    var modal = this.getEl("poc-demo-modal");

    if (closeBtn) {
      closeBtn.addEventListener("click", this.closeModal.bind(this));
    }

    if (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) {
          POC.ui.closeModal();
        }
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        POC.ui.closeModal();
      }
    });
  }
};